// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2IaHo","footer__text":"Footer_footer__text__2PC6c"};